import React, { Component, Fragment } from "react";
import List from "./List";
import Footer from "../../utilities/Footer";
import AppContext from "../../../contexts/AppContext";
import Header from "../Header";
import { records, filter } from "../../../services/client";
import { reject } from "../../../services/writerInvitation";
import NoData from "./../../utilities/NoData";
import LoadingData from "./../../utilities/LoadingData";
import Invitation from "./Invitation";

class Myclients extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        search: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all"
    };
    reject = id => {
        return reject(id).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp.splice(i, 1);
                    this.setState({ items: temp });
                }
            }
        });
    };
    accept = id => {
        return reject(id).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp.splice(i, 1);
                    this.setState({ items: temp });
                }
            }
        });
    };
    setActiveTab = tabName => {
        this.setState({ activeTab: tabName });
    };

    filter = item => {
        this.setState({ loading: true });
        filter(item).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                filter: true,
                loading: false,
                filterItem: item
            });
        });
    };
    clear = () => {
        this.setState({ loading: true });
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    componentDidMount() {
        this.clear();
    }
    render() {
        return (
            <Fragment>
                <div className="header">
                    <div className="header-body">
                        <div className="row align-items-center">
                            <div className="col">
                                <h1 className="header-title">
                                    Clients
                                </h1>
                                <h6 className="header-pretitle">
                                    Overview all clients
                                </h6>
                            </div>
                        </div>
                        <div className="row align-items-center">
                            <div className="col">
                                <ul className="nav nav-tabs nav-overflow header-tabs">
                                    <li className="nav-item">
                                        <button
                                            onClick={() =>
                                                this.filter(
                                                    "all"
                                                )
                                            }
                                            className={
                                                this.state
                                                    .filterItem ===
                                                "all"
                                                    ? `nav-link active`
                                                    : `nav-link `
                                            }
                                        >
                                            All{" "}
                                            <span className="badge badge-pill badge-soft-secondary">
                                                {
                                                    this.state
                                                        .meta
                                                        .total
                                                }
                                            </span>
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            onClick={() =>
                                                this.filter(
                                                    "approved"
                                                )
                                            }
                                            className={
                                                this.state
                                                    .filterItem ===
                                                "approved"
                                                    ? `nav-link active`
                                                    : `nav-link`
                                            }
                                        >
                                            Open{" "}
                                            <span className="badge badge-pill badge-soft-secondary">
                                                {
                                                    this.state
                                                        .meta
                                                        .approved
                                                }
                                            </span>
                                        </button>
                                    </li>

                                    <li className="nav-item">
                                        <button
                                            onClick={() =>
                                                this.filter(
                                                    "closed"
                                                )
                                            }
                                            className={
                                                this.state
                                                    .filterItem ===
                                                "closed"
                                                    ? `nav-link active`
                                                    : `nav-link`
                                            }
                                        >
                                            Closed{" "}
                                            <span className="badge badge-pill badge-soft-secondary">
                                                {
                                                    this.state
                                                        .meta
                                                        .closed
                                                }
                                            </span>
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            onClick={() =>
                                                this.filter(
                                                    "applied"
                                                )
                                            }
                                            className={
                                                this.state
                                                    .filterItem ===
                                                "applied"
                                                    ? `nav-link active`
                                                    : `nav-link`
                                            }
                                        >
                                            Pending{" "}
                                            <span className="badge badge-pill badge-soft-secondary">
                                                {
                                                    this.state
                                                        .meta
                                                        .applied
                                                }
                                            </span>
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            onClick={() =>
                                                this.filter(
                                                    "rejected"
                                                )
                                            }
                                            className={
                                                this.state
                                                    .filterItem ===
                                                "rejected"
                                                    ? `nav-link active`
                                                    : `nav-link`
                                            }
                                        >
                                            Declined{" "}
                                            <span className="badge badge-pill badge-soft-secondary">
                                                {
                                                    this.state
                                                        .meta
                                                        .rejected
                                                }
                                            </span>
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            onClick={() =>
                                                this.filter(
                                                    "invitation"
                                                )
                                            }
                                            className={
                                                this.state
                                                    .filterItem ===
                                                "invitation"
                                                    ? `nav-link active`
                                                    : `nav-link`
                                            }
                                        >
                                            Invitation{" "}
                                            <span className="badge badge-pill badge-soft-secondary">
                                                {
                                                    this.state
                                                        .meta
                                                        .invitation
                                                }
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
				    {/*<div className="card-header">
                        <div className="row align-items-center"></div>
	                </div>*/}
                    <div className="table-responsive">
                        {this.state.loading === true ? (
                            <LoadingData></LoadingData>
                        ) : this.state.items.length >= 1 ? (
                            this.state.filterItem !==
                            "invitation" ? (
                                <table
                                    id="DataTable"
                                    class="table table-sm table-nowrap card-table dataTable no-footer"
                                    role="grid"
                                    aria-describedby="DataTable_info"
                                >
                                    <thead>
                                        <tr role="row">
                                            <th>client</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody className="list">
                                        {this.state.items.map(
                                            (item, index) => {
                                                return (
                                                    <List
                                                        getItem={
                                                            this
                                                                .clear
                                                        }
                                                        item={
                                                            item
                                                        }
                                                        index={
                                                            index
                                                        }
                                                        key={
                                                            index
                                                        }
                                                    ></List>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            ) : (
                                <table
                                    id="DataTable"
                                    class="table table-sm table-nowrap card-table dataTable no-footer"
                                    role="grid"
                                    aria-describedby="DataTable_info"
                                >
                                    <thead>
                                        <tr>
                                            <th>
                                                <div className="custom-control custom-checkbox table-checkbox">
                                                    #
                                                </div>
                                            </th>
                                            <th>Job</th>
                                            <th>Date</th>
                                            <th className="Options">
                                                Options
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="list">
                                        {this.state.items.map(
                                            (item, index) => {
                                                return (
                                                    <Invitation
                                                        getItem={
                                                            this
                                                                .record
                                                        }
                                                        reject={
                                                            this
                                                                .reject
                                                        }
                                                        accept={
                                                            this
                                                                .accept
                                                        }
                                                        item={
                                                            item
                                                        }
                                                        index={
                                                            index
                                                        }
                                                        key={
                                                            index
                                                        }
                                                    ></Invitation>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            )
                        ) : (
                            <NoData></NoData>
                        )}
                    </div>
                    <div>
                        <Footer
                            changePage={this.changePage}
                            totalPages={this.state.meta.pages}
                            curentPage={this.state.meta.page}
                        ></Footer>
                    </div>
                </div>
			</Fragment>
        );
    }
}
Myclients.contextType = AppContext;
export default Myclients;



// WEBPACK FOOTER //
// ./src/components/writer/clients/Clients.js